import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=a60e5aa8&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=a60e5aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e5aa8",
  null
  
)

export default component.exports